import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExgModalService} from 'exc-controls-v2';

@Component({
  selector: 'app-receipt-report',
  templateUrl: './receipt-report.component.html',
  styles: [
  ]
})
export class ReceiptReportComponent extends ExcTranslation implements OnInit {
  @Input()
  data: any;

  reportParams = {
    withReceipts: true,
    withReviews: true
  };

  constructor(
    private modal: ExgModalService,
    public enumSvc: EnumerationService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
    // this.initEnumeration();
  }

  initialize(): void {

  }

  cancel(): void {
    this.modal.close();
  }

  save(): void {
    this.modal.action(this.reportParams);
  }
}
